import { branchName, preview } from "data/contentful/constants"
import type { SkinnyBanner } from "types"
import { type ApolloClient, type InMemoryCache, useQuery } from "@apollo/client"
import { getMemberSkinnyBanner, getSkinnyBanner } from "./SkinnyBanner.gql"
import { createRequestContext, getClient } from "../../../lib/apolloClient"

export const useSkinnyBannerData = (
  isMember: boolean
): { loading: boolean; data: SkinnyBanner[] } => {
  const { loading, data } = useQuery(
    isMember ? getMemberSkinnyBanner : getSkinnyBanner,
    {
      variables: {
        branchName,
        preview,
      },
      context: createRequestContext({
        sessionStrategy: isMember ? "START_NEW_ANONYMOUS" : "NONE",
      }),
      client: getClient() as ApolloClient<InMemoryCache>,
    }
  )

  return {
    loading,
    data: isMember
      ? data?.getMemberSkinnyBannerContent || []
      : data?.getSkinnyBannerContent || [],
  }
}
